"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var I18nPreferencesACSConfigClientImpl_1 = __importDefault(require("./I18nPreferencesACSConfigClientImpl"));
var I18nPreferencesACSConfigClientProvider = /** @class */ (function () {
    function I18nPreferencesACSConfigClientProvider() {
        this.CONTEXTUAL_PARAMETERS = ["i18n_cx_family", "i18n_cx_id", "i18n_cx_program"];
        this.STAGE_VERSION_LABEL_NAME = "AcsI18nPreferencesACSConfig";
        this.TABLE_NAME = "acs_I18nPreferencesACSConfig";
    }
    I18nPreferencesACSConfigClientProvider.prototype.createTypeSafeClient = function (configSet) {
        return new I18nPreferencesACSConfigClientImpl_1.default(configSet);
    };
    return I18nPreferencesACSConfigClientProvider;
}());
exports.default = I18nPreferencesACSConfigClientProvider;
